<template>
  <div>
    <v-btn @click="showBox" v-if="!showReplyBox">
      답변하기
    </v-btn>
    <div v-if="showReplyBox">
      <v-textarea
        outlined
        auto-grow
        rows="1"
        row-height="15"
        name="input"
        label="답변을 입력해주세요."
        value=""
        v-model="reply"
      ></v-textarea>
      <v-btn @click="removeReply">취소</v-btn>
      <v-btn @click="addReply">완료</v-btn>
    </div>
    <div>
      <template v-for="(data, i) in data.reply">
        <div :key="i" class="reply-box">
          <div class="reply-icon"><v-icon> mdi-arrow-right-bottom-bold </v-icon></div>
          <div class="reply-data">
            <div class="reply-title">{{ data.writer }}</div>
            <div class="reply-content">{{ data.comment }}</div>
            <div class="reply-date">{{ replyDate(data.created_at) }}</div>
            <v-btn v-if="getUser.email === data.writer" @click="deleteReply(data.id)">삭제</v-btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { BASE_API_URL } from '../../../store/api'

export default {
  props: ['data', 'board_id', 'type'],
  data () {
    return {
      showReplyBox: false,
      reply: '',
      replys: []
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'getUser'])
  },
  methods: {
    showBox () {
      this.showReplyBox = true
    },
    replyDate (arg) {
      const date = arg.toString().substring(0, 10)
      const time = arg.toString().substring(11, 16)
      return date + ' ' + time
    },
    addReply () {
      axios.post(`${BASE_API_URL}/edu/${this.type}/${this.board_id}/comments/${this.data.id}/`,
        {
          email: this.getUser.email,
          content: this.reply
        }, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: this.$store.state.auth.access
          }
        }
      ).then((res) => {
        this.$emit('replySuccess')
        this.reply = ''
      }).catch((err) => {
        console.error(err)
      })
    },
    removeReply () {
      this.showReplyBox = false
      this.reply = ''
    },
    deleteReply (id) {
      axios.delete(`${BASE_API_URL}/edu/${this.type}/${this.board_id}/comments/${this.data.id}/`, {
        data: {
          id: id
        }
      }).then((res) => {
        this.$emit('replyDelete')
      }).catch((err) => {
        console.error(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .reply-box {
    display: flex;
    position: relative;
    border: 1px dotted black;
  }
</style>
